import { useQuery } from '@tanstack/vue-query'
import type { LicenseDetails } from '~~/types/LicenseDetails'
import type { LicenseModel } from '~~/types/LicenseModel'

const validLicenseModels: LicenseModel[] = ['OPEN', 'SCHOOL', 'INDIVIDUAL', 'PRIVATE', 'TRIAL_SCHOOL']
const isValid = (licenseModel: string): licenseModel is LicenseModel => {
  return validLicenseModels.includes(licenseModel as LicenseModel)
}

const isExpired = (date: string) => {
  return new Date(date) < new Date()
}

export const useLicenseDetails = () => {
  const { t } = useI18n()
  const { fetchCoreExternal } = useVgsFetch()

  return useQuery<LicenseDetails[]>({
    queryKey: ['licenseDetails'],
    queryFn: () => fetchCoreExternal('/frontend/licenses/details?site=MODUS'),
    select: data => data.map(({ licenseModel, startDate, endDate, ...rest }: LicenseDetails) => ({
      ...rest,
      startDate: formatNorwegianDate(startDate),
      endDate: formatNorwegianDate(endDate),
      isExpired: isExpired(endDate),
      licenseModel: isValid(licenseModel) ? t(`licenseModel.${licenseModel}`) : 'Ukjent',
    })),
  })
}
